import React from "react";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import Cities from "./cities";
import ReactMapboxGl, { GeoJSONLayer, ZoomControl } from "react-mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import csv2geojson from "csv2geojson";
import { RadialChart, RadarChart } from "react-vis";
import "./App.css";
import axios from "axios";
const zoom = [8];

const Map = ReactMapboxGl({
  accessToken:
    "pk.eyJ1IjoicmFpY2h1ciIsImEiOiJCX2J1Uk1jIn0.Dss8lGxgTYKK1jDusc4lJw",
});

const DOMAIN = [
  { name: "N", domain: [0, 100] },
  { name: "NW", domain: [0, 100] },
  { name: "W", domain: [0, 100] },
  { name: "SW", domain: [0, 100] },
  { name: "W", domain: [0, 100] },
  { name: "SE", domain: [0, 100] },
  { name: "E", domain: [0, 100] },
  { name: "NE", domain: [0, 100] },
];

// Home Page
const HomePage = () => {
  return (
    <>
      <h1 className="content title">
        <Link to="/">Commute Flows</Link>
      </h1>
      <ul className="citiesList content">
        {Cities.map((city, i) => (
          <li key={i}>
            <Link
              to={`/city/${city.url}`}
              key={i}
              style={{ backgroundImage: `url(/data/thumbs/${city.url}.jpg)` }}
            >
              <h3>{city.fullTitle}</h3>
              <p>{city.state}</p>
            </Link>
          </li>
        ))}
      </ul>
      <footer className="content">
        Made by <a href="https://joshuaraichur.com">Josh</a> •{" "}
        <Link to="/about">About</Link>
      </footer>
    </>
  );
};

// About Page
const AboutPage = () => {
  return (
    <>
      <h1 className="content title">
        <Link to="/">Commute Flows</Link>
      </h1>
      <div className="content aboutPage">
        <h2>About</h2>
        <p>
          Made using React, React-Vis, and Mapbox GL JS. Data is the latest
          available (2017) from the{" "}
          <a href="https://onthemap.ces.census.gov/">US Census Bureau</a>,
          cleaned with QGIS and Pandas.
        </p>
        <p>
        It shows where people work vs where they live, along with demographic distribution of a few American cities.
        </p>
      </div>
      <footer className="content">
        Made by <a href="https://joshuaraichur.com">Josh</a> •{" "}
        <Link to="/about">About</Link>
      </footer>
    </>
  );
};

// City Page
class MapComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      showLoading: true,
      window: 0,
      home: true,
      curCity: "",
      center: [95.7129, 37.0902],
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.state.home) {
      this.setState({ home: false });
    } else {
      this.setState({ home: true });
    }
  }

  onStyleLoad() {
    this.setState({ showLoading: false });
  }

  async componentDidMount() {
    let curCity = this.props.location.pathname.replace("/city/", "");

    let curThis = this;
    for (let city in Cities) {
      if (Cities[city].url === curCity) {
        this.setState({ curCity: Cities[city], center: Cities[city].center });
      }
    }

    // Get current city CSV file and convert to GeoJSON
    await axios.get(`../data/${curCity}.csv`).then(function (response) {
      makeGeoJSON(response.data);
    });
    function makeGeoJSON(csvData) {
      csv2geojson.csv2geojson(
        csvData,
        {
          latfield: "ycoord",
          lonfield: "xcoord",
        },
        function (err, data) {
          data.features.map((feature) => {
            for (let property in feature.properties) {
              feature.properties[property] = Number(
                feature.properties[property]
              );
            }
            return data.features;
          });
          curThis.setState({ results: data });
        }
      );
    }
  }

  // Map Page Layout
  render() {
    return (
      <div className="App mapApp">
        <div className="sidebar">
          <div className="controls">
            <h1>
              <Link to="/">Commute Flows</Link>
            </h1>
            <div
              className="loading"
              style={{
                display: this.state.showLoading ? "block" : "none",
              }}
            >
              <svg
                className="spinner"
                width="35px"
                height="35px"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="path"
                  fill="none"
                  strokeWidth="6"
                  strokeLinecap="round"
                  cx="33"
                  cy="33"
                  r="30"
                ></circle>
              </svg>
            </div>
          </div>

          {this.state.curCity ? (
            <>
            <div className="controlContainer block">
            {this.state.home ? (
              <p>
                Currently showing: <b>Home</b>
              </p>
            ) : (
              <p>
                Currently showing: <b>Work</b>
              </p>
            )}
            <div className="button" onClick={this.handleClick}>
              {this.state.home ? "Show Work" : "Show Home"}
            </div>
          </div>
            <div className="stats">
              

              <div className="block raceBlock">
                <h3>Race</h3>
                <div>
                  
                  <h4><span className="green"></span> Asian </h4>
                  <p>{this.state.curCity.stats.race.asian[1]}%</p>
                </div>
                <div>
                  
                  <h4><span className="blue"></span> Black </h4>
                  <p>{this.state.curCity.stats.race.black[1]}%</p>
                </div>
                <div>
                  
                  <h4><span className="red"></span> White </h4>
                  <p>{this.state.curCity.stats.race.white[1]}%</p>
                </div>
                <div>
                  <h4>Pacific Islander</h4>
                  <p>{this.state.curCity.stats.race.pacific[1]}%</p>
                </div>
                <div>
                  <h4>American Indian</h4>
                  <p>{this.state.curCity.stats.race.native[1]}%</p>
                </div>
                <div>
                  <h4>Mixed Race</h4>
                  <p>{this.state.curCity.stats.race.mixed[1]}%</p>
                </div>
              </div>

              <div className="block ethnicityBlock">
                <h3>Ethnicity</h3>
                <div className="blockFlex">
                  <div className="leftFlex">
                    <div>
                      <h4>Hispanic or Latino</h4>
                      <p>{this.state.curCity.stats.ethnicity.latino[1]}%</p>
                    </div>
                    <div>
                      <h4>Not Hispanic or Latino</h4>
                      <p>{this.state.curCity.stats.ethnicity.notLatino[1]}%</p>
                    </div>
                  </div>
                  <div className="rightFlex">
                    <RadialChart
                      data={[
                        {
                          label: "Not Hispanic or Latino",
                          angle: this.state.curCity.stats.ethnicity
                            .notLatino[1],
                        },
                        {
                          label: "Hispanic or Latino",
                          angle: this.state.curCity.stats.ethnicity.latino[1],
                        },
                      ]}
                      width={90}
                      height={90}
                    />
                  </div>
                </div>
              </div>

              <div className="block sexBlock">
                <h3>Sex</h3>
                <div className="blockFlex">
                  <div className="leftFlex">
                    <div>
                      <h4>Female</h4>
                      <p>{this.state.curCity.stats.sex.female[1]}%</p>
                    </div>
                    <div>
                      <h4>Male</h4>
                      <p>{this.state.curCity.stats.sex.male[1]}%</p>
                    </div>
                  </div>
                  <div className="rightFlex">
                    <RadialChart
                      data={[
                        {
                          label: "Male",
                          angle: this.state.curCity.stats.sex.male[1],
                        },
                        {
                          label: "Female",
                          angle: this.state.curCity.stats.sex.female[1],
                        },
                      ]}
                      width={90}
                      height={90}
                    />
                  </div>
                </div>
              </div>

              <div className="block directionBlock">
                <h3>Direction of Commute</h3>
                <RadarChart
                  animation
                  data={[
                    {
                      N:
                        (Number(
                          this.state.curCity.stats.direction.north.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        400,
                      NE:
                        (Number(
                          this.state.curCity.stats.direction.northeast.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        400,
                      E:
                        (Number(
                          this.state.curCity.stats.direction.east.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        500,
                      SE:
                        (Number(
                          this.state.curCity.stats.direction.southeast.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        400,
                      S:
                        (Number(
                          this.state.curCity.stats.direction.south.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        400,
                      SW:
                        (Number(
                          this.state.curCity.stats.direction.southwest.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        400,
                      W:
                        (Number(
                          this.state.curCity.stats.direction.west.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        400,
                      NW:
                        (Number(
                          this.state.curCity.stats.direction.northwest.total[0]
                        ) /
                          Number(
                            this.state.curCity.stats.direction.total.total[0]
                          )) *
                        400,
                    },
                  ]}
                  domains={DOMAIN}
                  style={{
                    polygons: {
                      fillOpacity: 0,
                      strokeWidth: 3,
                    },
                    axes: {
                      text: {
                        opacity: 0,
                      },
                    },
                  }}
                  margin={{
                    left: 40,
                    top: 40,
                    bottom: 40,
                    right: 40,
                  }}
                  tickFormat={(t) => ""}
                  width={320}
                  height={320}
                ></RadarChart>
              </div>
            </div>
            </>
          ) : null}
        </div>

        <div className="mainbar">
          <Map
            style={`mapbox://styles/raichur/ckc4b30ap0inr1imp9v1gj9ig`}
            zoom={zoom}
            center={this.state.center}
            containerStyle={{
              height: "calc(100vh - 30px)",
              width: "calc(100% - 15px)",
              margin: "15px 0 15px 15px",
              marginLeft: "0",
              border: "1px solid rgba(255,255,255,0.2)",
            }}
            onStyleLoad={this.onStyleLoad.bind(this)}
          >
            <ZoomControl />
            <GeoJSONLayer
              data={this.state.results}
              circleLayout={{
                visibility: "visible",
              }}
              circlePaint={{
                "circle-color": [
                  "rgb",
                  [
                    "*",
                    [
                      "/",
                      ["get", this.state.home ? "h_cr01" : "cr01"],
                      ["match", ["get", this.state.home ? "h_c000" : "c000"], 0, 1, ["get", this.state.home ? "h_c000" : "c000"]]
                    ],
                    255,
                  ],
                  [
                    "*",
                    [
                      "/",
                      ["get", this.state.home ? "h_cr04" : "cr04"],
                      ["match", ["get", this.state.home ? "h_c000" : "c000"], 0, 1, ["get", this.state.home ? "h_c000" : "c000"]]
                    ],
                    255,
                  ],
                  [
                    "*",
                    [
                      "/",
                      ["get", this.state.home ? "h_cr02" : "cr02"],
                      ["match", ["get", this.state.home ? "h_c000" : "c000"], 0, 1, ["get", this.state.home ? "h_c000" : "c000"]]
                    ],
                    255,
                  ],
                ],
                "circle-stroke-color": "#750715",
                "circle-stroke-opacity": 0.5,
                "circle-stroke-width": 0,
                "circle-blur": 0.1,
                "circle-radius": {
                  property: this.state.home ? "h_c000" : "c000",
                  stops: [
                    [{ zoom: 8, value: 10 }, 1],
                    [{ zoom: 8, value: 200 }, 1.5],
                    [{ zoom: 8, value: 1000 }, 2],
                    [{ zoom: 12, value: 10 }, 1.5],
                    [{ zoom: 12, value: 200 }, 3],
                    [{ zoom: 12, value: 1000 }, 5],
                    [{ zoom: 16, value: 1 }, 5],
                    [{ zoom: 16, value: 200 }, 7],
                    [{ zoom: 16, value: 1000 }, 8],
                    [{ zoom: 16, value: 2000 }, 10],
                  ],
                },
              }}
            />
          </Map>
        </div>
      </div>
    );
  }
}

// Router
const App = () => {
  return (
    <>
      <Router>
        <Route exact path="/" component={HomePage} />
        <Route path="/about" component={AboutPage} />
        <Route path="/city/:personId" component={MapComp} />
      </Router>
    </>
  );
};

export default App;
